import { render, staticRenderFns } from "./alertType.vue?vue&type=template&id=6c65d029"
import script from "./alertType.vue?vue&type=script&lang=js"
export * from "./alertType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports